module.exports = __webpack_public_path__ + "static/media/xslego-8-editor.8fb6b1ee.png";